// @flow
import { useTranslator } from '@gandi/translate';

import { ContactForm } from 'src/Cart/ContactForm';

import { useCartSummaryContext } from 'src/Layout/context/CartSummary';

import type { Props } from '../../hooks/useModalType';

import { ModalFooter } from './ModalFooter';

// If no orga => POST new orga
// If orga => PATCH update orga
export function ContactFormModal(props: Props): React.MixedElement {
  const { __ } = useTranslator();

  const { onClose, onBack, contact, role, setCurrentRadioValue } = props;

  const { submitting } = useCartSummaryContext();

  return (
    <div>
      <ContactForm
        key={contact?.id || 'new'}
        contact={contact}
        onSuccess={
          props.actionOnSuccess ? props[props.actionOnSuccess] : onClose
        }
        role={role}
        setCurrentRadioValue={setCurrentRadioValue}
      />
      <ModalFooter
        secondaryButtonProps={
          onBack ? { children: __('Back'), onClick: onBack } : undefined
        }
        primaryButtonProps={{
          children: __('Save'),
          type: 'submit',
          attributes: { form: 'account-form' },
          loading: submitting,
        }}
      />
    </div>
  );
}
